import React from "react";
import { useNavigate } from "react-router-dom";
import { ConfirmationModal, TailwindToaster } from "../../../components";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";

import axios from "../../../api/axios";

const InputSettings = () => {
  const state = useSelector((state) => state.UserReducer);
  const navigate = useNavigate();
  const departmentUrl = "/department";
  const teamUrl = "/team";
  const serviceUrl = "/service";
  const subServiceUrl = "/subservice";
  const propertyUrl = "/propertyoption";
  const subPropertyUrl = "/subpropertyoption";
  const serviceSubStatusUrl = "/servicesubstatus";
  const pifLocationUrl = "/pifLocation";

  const [refreshData, setRefreshData] = React.useState(0);
  const [popupId, setPopupId] = React.useState(null);
  const [component, setComponent] = React.useState("");
  const popupCallback = (canProceed) => {
    if (canProceed) {
      switch (component) {
        case "Department":
          deleteDepartment(popupId);
          break;
        case "Team":
          deleteTeam(popupId);
          break;
        case "Service":
          deleteService(popupId);
          break;
        case "SubService":
          deleteSubService(popupId);
          break;
        case "Property":
          deleteProperty(popupId);
          break;
        case "SubProperty":
          deleteSubProperty(popupId);
        case "ServiceSubStatus":
          deleteServiceSubStatus(popupId);
        case "PIFLocation":
          deletePIFLocation(popupId);
      }
    }
    setPopupId(null);
  };
  const closeConfirmation = () => {
    setPopupId(null);
  };

  const [departmentEditId, setDepartmentEditId] = React.useState(null);
  const [departmentServerData, setDepartmentServerData] = React.useState([]);
  const updateDepartment = (departmentId, name, description) => {
    try {
      axios
        .put(
          departmentUrl + "/" + departmentId,
          JSON.stringify({
            name,
            description,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setDepartmentEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const getDepartments = () => {
    try {
      axios
        .get(departmentUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.departments?.length > 0) {
            setDepartmentServerData(response.data.departments);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const editDepartment = (departmentEditId) => {
    const name = document.getElementById("editDeptName").value;
    const description = document.getElementById("editDeptDescription").value;
    updateDepartment(departmentEditId, name, description);
  };
  const deleteOnClickDepartment = (departmentDeleteId) => {
    setPopupId(departmentDeleteId);
    setComponent("Department");
  };
  const deleteDepartment = (departmentDeleteId) => {
    try {
      axios
        .delete(departmentUrl + "/" + departmentDeleteId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            setPopupId(null);
            toast.success(response?.data?.message);
            setDepartmentEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const newDepartment = () => {
    const name = document.getElementById("newDeptName").value;
    const description = document.getElementById("newDeptDescription").value;
    try {
      axios
        .post(
          departmentUrl,
          JSON.stringify({
            name,
            description,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setRefreshData(refreshData + 1);
            document.getElementById("newDeptName").value = "";
            document.getElementById("newDeptDescription").value = "";
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [teamEditId, setTeamEditId] = React.useState(null);
  const [teamServerData, setTeamServerData] = React.useState([]);
  const updateTeam = (teamId, name, description, departmentId) => {
    try {
      axios
        .put(
          teamUrl + "/" + teamId,
          JSON.stringify({
            name,
            description,
            departmentId,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setTeamEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const getTeams = () => {
    try {
      axios
        .get(teamUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.teams?.length > 0) {
            setTeamServerData(response.data.teams);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const editTeam = (teamEditId) => {
    const name = document.getElementById("editTeamName").value;
    const description = document.getElementById("editTeamDescription").value;
    const departmentId = document.getElementById("editTeamDepartmentId").value;
    updateTeam(teamEditId, name, description, departmentId);
  };
  const deleteOnClickTeam = (teamDeleteId) => {
    setPopupId(teamDeleteId);
    setComponent("Team");
  };
  const deleteTeam = (teamDeleteId) => {
    try {
      axios
        .delete(teamUrl + "/" + teamDeleteId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            setPopupId(null);
            toast.success(response?.data?.message);
            setTeamEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const newTeam = () => {
    const name = document.getElementById("newTeamName").value;
    const description = document.getElementById("newTeamDescription").value;
    const departmentId = document.getElementById("newTeamDepartmentId").value;
    try {
      axios
        .post(
          teamUrl,
          JSON.stringify({
            name,
            description,
            departmentId,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setRefreshData(refreshData + 1);
            document.getElementById("newTeamName").value = "";
            document.getElementById("newTeamDescription").value = "";
            document.getElementById("newTeamDepartmentId").value = "";
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [serviceEditId, setServiceEditId] = React.useState(null);
  const [serviceServerData, setServiceServerData] = React.useState([]);
  const [departmentForServiceServerData, setDepartmentForServiceServerData] =
    React.useState([]);
  const updateService = (serviceId, name, description, departmentId) => {
    try {
      axios
        .put(
          serviceUrl + "/" + serviceId,
          JSON.stringify({
            name,
            description,
            departmentId,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setServiceEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const getServices = () => {
    try {
      axios
        .get(serviceUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.services?.length > 0) {
            setServiceServerData(response.data.services);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const getDepartmentsForService = () => {
    try {
      axios
        .get(departmentUrl + "/forservice", {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.departments?.length > 0) {
            setDepartmentForServiceServerData(response.data.departments);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const editService = (serviceEditId) => {
    const name = document.getElementById("editServiceName").value;
    const description = document.getElementById("editServiceDescription").value;
    const departmentId = document.getElementById(
      "editServiceDepartmentId",
    ).value;
    updateService(serviceEditId, name, description, departmentId);
  };
  const deleteOnClickService = (serviceDeleteId) => {
    setPopupId(serviceDeleteId);
    setComponent("Service");
  };
  const deleteService = (serviceDeleteId) => {
    try {
      axios
        .delete(serviceUrl + "/" + serviceDeleteId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            setPopupId(null);
            toast.success(response?.data?.message);
            setServiceEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const newService = () => {
    const name = document.getElementById("newServiceName").value;
    const description = document.getElementById("newServiceDescription").value;
    const departmentId = document.getElementById(
      "newServiceDepartmentId",
    ).value;
    try {
      axios
        .post(
          serviceUrl,
          JSON.stringify({
            name,
            description,
            departmentId,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setRefreshData(refreshData + 1);
            document.getElementById("newServiceName").value = "";
            document.getElementById("newServiceDescription").value = "";
            document.getElementById("newServiceDepartmentId").value = "";
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [subServiceEditId, setSubServiceEditId] = React.useState(null);
  const [subServiceServerData, setSubServiceServerData] = React.useState([]);
  const updateSubService = (subServiceId, serviceId, name) => {
    try {
      axios
        .put(
          subServiceUrl + "/" + subServiceId,
          JSON.stringify({
            serviceId,
            name,
            description: "",
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setSubServiceEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const getSubServices = () => {
    try {
      axios
        .get(subServiceUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.subservices?.length > 0) {
            setSubServiceServerData(response.data.subservices);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const editSubService = (subServiceEditId) => {
    const serviceId = document.getElementById("editSubServiceSuperId").value;
    const name = document.getElementById("editSubServiceName").value;
    updateSubService(subServiceEditId, serviceId, name);
  };
  const deleteOnClickSubService = (subServiceDeleteId) => {
    setPopupId(subServiceDeleteId);
    setComponent("SubService");
  };
  const deleteSubService = (subServiceDeleteId) => {
    try {
      axios
        .delete(subServiceUrl + "/" + subServiceDeleteId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            setPopupId(null);
            toast.success(response?.data?.message);
            setSubServiceEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const newSubService = () => {
    const serviceId = document.getElementById("newSubServiceSuperId").value;
    const name = document.getElementById("newSubServiceName").value;
    try {
      axios
        .post(
          subServiceUrl,
          JSON.stringify({
            serviceId,
            name,
            description: "",
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setRefreshData(refreshData + 1);
            // document.getElementById("newSubServiceSuperId").value =
            //   "62c81630a085a705355bbd71";
            document.getElementById("newSubServiceName").value = "";
            // document.getElementById("newSubServiceDescription").value = "";
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [propertyEditId, setPropertyEditId] = React.useState(null);
  const [propertyServerData, setPropertyServerData] = React.useState([]);
  const updateProperty = (propertyId, name, description) => {
    try {
      axios
        .put(
          propertyUrl + "/" + propertyId,
          JSON.stringify({
            name,
            description,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setPropertyEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const getPropertys = () => {
    try {
      axios
        .get(propertyUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.properties?.length > 0) {
            setPropertyServerData(response.data.properties);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const editProperty = (propertyEditId) => {
    const name = document.getElementById("editPropertyName").value;
    const description = document.getElementById(
      "editPropertyDescription",
    ).value;
    updateProperty(propertyEditId, name, description);
  };
  const deleteOnClickProperty = (propertyDeleteId) => {
    setPopupId(propertyDeleteId);
    setComponent("Property");
  };
  const deleteProperty = (propertyDeleteId) => {
    try {
      axios
        .delete(propertyUrl + "/" + propertyDeleteId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            setPopupId(null);
            toast.success(response?.data?.message);
            setPropertyEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const newProperty = () => {
    const name = document.getElementById("newPropertyName").value;
    const description = document.getElementById("newPropertyDescription").value;
    try {
      axios
        .post(
          propertyUrl,
          JSON.stringify({
            name,
            description,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setRefreshData(refreshData + 1);
            document.getElementById("newPropertyName").value = "";
            document.getElementById("newPropertyDescription").value = "";
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const [pifLocationEditId, setPIFLocationEditId] = React.useState(null);
  const [pifLocationServerData, setPIFLocationServerData] = React.useState([]);
  const updatePIFLocation = (pifLocationId, name) => {
    try {
      axios
        .put(
          pifLocationUrl + "/" + pifLocationId,
          JSON.stringify({
            name,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setPIFLocationEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const getPIFLocations = () => {
    try {
      axios
        .get(pifLocationUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.pifLocations?.length > 0) {
            setPIFLocationServerData(response.data.pifLocations);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const editPIFLocation = (pifLocationEditId) => {
    const name = document.getElementById("editPIFLocationName").value;
    updatePIFLocation(pifLocationEditId, name);
  };
  const deleteOnClickPIFLocation = (pifLocationDeleteId) => {
    setPopupId(pifLocationDeleteId);
    setComponent("PIFLocation");
  };
  const deletePIFLocation = (pifLocationDeleteId) => {
    try {
      axios
        .delete(pifLocationUrl + "/" + pifLocationDeleteId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            setPopupId(null);
            toast.success(response?.data?.message);
            setPIFLocationEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const newPIFLocation = () => {
    const name = document.getElementById("newPIFLocationName").value;
    try {
      axios
        .post(
          pifLocationUrl,
          JSON.stringify({
            name,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setRefreshData(refreshData + 1);
            document.getElementById("newPIFLocationName").value = "";
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [subPropertyEditId, setSubPropertyEditId] = React.useState(null);
  const [subPropertyServerData, setSubPropertyServerData] = React.useState([]);
  const updateSubProperty = (subPropertyId, propertyId, name) => {
    try {
      axios
        .put(
          subPropertyUrl + "/" + subPropertyId,
          JSON.stringify({
            propertyOptionId: propertyId,
            name,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setSubPropertyEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const getSubPropertys = () => {
    try {
      axios
        .get(subPropertyUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.subPropertyOptions?.length > 0) {
            setSubPropertyServerData(response.data.subPropertyOptions);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const editSubProperty = (subPropertyEditId) => {
    const propertyId = document.getElementById("editSubPropertySuperId").value;
    const name = document.getElementById("editSubPropertyName").value;
    updateSubProperty(subPropertyEditId, propertyId, name);
  };
  const deleteOnClickSubProperty = (subPropertyDeleteId) => {
    setPopupId(subPropertyDeleteId);
    setComponent("SubProperty");
  };
  const deleteSubProperty = (subPropertyDeleteId) => {
    try {
      axios
        .delete(subPropertyUrl + "/" + subPropertyDeleteId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            setPopupId(null);
            toast.success(response?.data?.message);
            setSubPropertyEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const newSubProperty = () => {
    const propertyId = document.getElementById("newSubPropertySuperId").value;
    const name = document.getElementById("newSubPropertyName").value;
    // const description = document.getElementById(
    //   "newSubPropertyDescription",
    // ).value;
    try {
      axios
        .post(
          subPropertyUrl,
          JSON.stringify({
            propertyOptionId: propertyId,
            name,
            description: "",
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setRefreshData(refreshData + 1);
            // document.getElementById("newSubPropertySuperId").value =
            //   "62c81630a085a705355bbd71";
            document.getElementById("newSubPropertyName").value = "";
            // document.getElementById("newSubPropertyDescription").value = "";
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [
    subServiceForSubStatusServerData,
    setSubServiceForSubStatusServerData,
  ] = React.useState([]);
  const [serviceSubStatusEditId, setServiceSubStatusEditId] =
    React.useState(null);
  const [serviceSubStatusServerData, setServiceSubStatusServerData] =
    React.useState([]);

  const updateSubServiceForSubStatus = (serviceTypeId) => {
    try {
      axios
        .get(subServiceUrl + "/" + serviceTypeId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.subservice?.length > 0) {
            setSubServiceForSubStatusServerData(response.data.subservice);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const getServiceSubStatus = () => {
    try {
      axios
        .get(serviceSubStatusUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.serviceSubStatuss?.length > 0) {
            setServiceSubStatusServerData(response.data.serviceSubStatuss);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const newServiceSubStatus = () => {
    const serviceId = document.getElementById(
      "newServiceSubStatusSuperId",
    ).value;
    const subServiceId = document.getElementById(
      "newServiceSubStatusSubServiceId",
    ).value;
    const name = document.getElementById("newServiceSubStatusName").value;
    const description = document.getElementById(
      "newServiceSubStatusDescription",
    ).value;
    try {
      axios
        .post(
          serviceSubStatusUrl,
          JSON.stringify({
            serviceId,
            subServiceId,
            name,
            description,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setRefreshData(refreshData + 1);
            document.getElementById("newServiceSubStatusSuperId").value = "";
            document.getElementById("newServiceSubStatusSubServiceId").value =
              "";
            document.getElementById("newServiceSubStatusName").value = "";
            document.getElementById("newServiceSubStatusDescription").value =
              "";
            setSubServiceForSubStatusServerData([]);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const deleteServiceSubStatus = (serviceSubStatusId) => {
    try {
      axios
        .delete(serviceSubStatusUrl + "/" + serviceSubStatusId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setServiceSubStatusEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const deleteOnClickServiceSubStatus = (serviceSubStatusId) => {
    setPopupId(serviceSubStatusId);
    setComponent("ServiceSubStatus");
  };
  const editServiceSubStatus = (serviceSubStatusId) => {
    const serviceId = document.getElementById(
      "editServiceSubStatusSuperId",
    ).value;
    const subServiceId = document.getElementById(
      "editServiceSubStatusSubServiceId",
    ).value;
    const name = document.getElementById("editServiceSubStatusName").value;
    const description = document.getElementById(
      "editServiceSubStatusDescription",
    ).value;
    updateServiceSubStatus(
      serviceSubStatusId,
      serviceId,
      subServiceId,
      name,
      description,
    );
  };
  const updateServiceSubStatus = (
    serviceSubStatusId,
    serviceId,
    subServiceId,
    name,
    description,
  ) => {
    try {
      axios
        .put(
          serviceSubStatusUrl + "/" + serviceSubStatusId,
          JSON.stringify({
            serviceId,
            subServiceId,
            name,
            description,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setServiceSubStatusEditId(null);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const [pageTitle, setPageTitle] = React.useState("Lands & Lands ERP");
  React.useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  React.useEffect(() => {
    // window.scrollTo({
    //   top: 0,
    //   left: 0,
    //   behavior: "smooth",
    // });
    getDepartments();
    getTeams();
    getServices();
    getDepartmentsForService();
    getSubServices();
    getPropertys();
    getPIFLocations();
    getSubPropertys();
    getServiceSubStatus();
    setPageTitle("Settings - L&L ERP");
  }, [refreshData]);

  return (
    <>
      {popupId && (
        <ConfirmationModal
          actionName={<strong>Delete</strong>}
          deleteConfirmation={popupCallback}
          moduleName={"Delete"}
          closeConfirmation={closeConfirmation}
          itemName={component}
        />
      )}
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='lg:flex lg:items-center justify-between'>
              <div className='flex-1 min-w-0 px-5 lg:px-0'>
                <h2 className='mt-4 ml-1 text-xl font-normal leading-7 text-gray-dark sm:text-lg '>
                  Form Input Option Settings
                </h2>
              </div>
            </div>
            <div className='px-4 py-2 sm:px-0'>
              <TailwindToaster />
              <div className='hidden sm:block  overflow-x-auto'>
                <div className='grid grid-cols-2'>
                  <div className='pr-2'>
                    <h2 className='mt-1 ml-1 text-base font-semibold leading-7 text-gray-dark '>
                      Departments
                    </h2>
                    <table className='table-auto w-full bg-white shadow rounded-sm border border-gray-100 '>
                      <thead className=' border-b-2 border-yellow'>
                        <tr>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                            Name
                          </th>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-left'>
                            Description
                          </th>
                          <th
                            colSpan='2'
                            className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'></th>
                        </tr>
                      </thead>
                      <tbody>
                        {departmentServerData?.length > 0 &&
                          departmentServerData?.map((item) => (
                            <tr key={item?._id} className='hover:shadow-lg'>
                              <td className='px-3 py-2 text-xs text-center'>
                                {departmentEditId === item?._id ? (
                                  <input
                                    type='text'
                                    name='editDeptName'
                                    id='editDeptName'
                                    maxLength='20'
                                    placeholder='Name'
                                    defaultValue={item?.name}
                                    className='focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm'
                                  />
                                ) : (
                                  item?.name
                                )}
                              </td>
                              <td className='px-3 py-2 font-normal text-xs tracking-wide text-left'>
                                {departmentEditId === item?._id ? (
                                  <input
                                    type='text'
                                    name='editDeptDescription'
                                    id='editDeptDescription'
                                    maxLength='50'
                                    placeholder='Description'
                                    defaultValue={item?.description}
                                    className='focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm'
                                  />
                                ) : (
                                  item?.description
                                )}
                              </td>
                              {departmentEditId === item?._id ? (
                                <td
                                  onClick={(e) => {
                                    editDepartment(item?._id);
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Update
                                </td>
                              ) : (
                                <td
                                  onClick={(e) => {
                                    setDepartmentEditId(item?._id);
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Edit
                                </td>
                              )}
                              <td
                                onClick={(e) => {
                                  deleteOnClickDepartment(item?._id);
                                }}
                                className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-red-600 text-center cursor-pointer'>
                                Delete
                              </td>
                            </tr>
                          ))}
                        {departmentEditId === null && (
                          <tr className='hover:shadow-lg'>
                            <td className='px-3 py-2'>
                              <input
                                type='text'
                                name='newDeptName'
                                id='newDeptName'
                                maxLength='20'
                                placeholder='Name'
                                className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm`}
                              />
                            </td>
                            <td className='px-3 py-1'>
                              <input
                                type='text'
                                name='newDeptDescription'
                                id='newDeptDescription'
                                maxLength='50'
                                placeholder='Description'
                                className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm`}
                              />
                            </td>
                            <td
                              colSpan='2'
                              onClick={(e) => {
                                newDepartment();
                              }}
                              className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                              Add
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className='pl-2'>
                    <h2 className='mt-1 ml-1 text-base font-semibold leading-7 text-gray-dark '>
                      Teams
                    </h2>
                    <table className='table-auto w-full bg-white shadow rounded-sm border border-gray-100 '>
                      <thead className=' border-b-2 border-yellow'>
                        <tr>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                            Name
                          </th>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-left'>
                            Description
                          </th>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-left'>
                            Department
                          </th>
                          <th
                            colSpan='2'
                            className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'></th>
                        </tr>
                      </thead>
                      <tbody>
                        {teamServerData?.length > 0 &&
                          teamServerData?.map((item) => (
                            <tr key={item?._id} className='hover:shadow-lg'>
                              <td className='px-3 py-2 text-xs text-center'>
                                {teamEditId === item?._id ? (
                                  <input
                                    type='text'
                                    name='editTeamName'
                                    id='editTeamName'
                                    maxLength='20'
                                    placeholder='Name'
                                    defaultValue={item?.name}
                                    className='focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm'
                                  />
                                ) : (
                                  item?.name
                                )}
                              </td>
                              <td className='px-3 py-2 font-normal text-xs tracking-wide text-left'>
                                {teamEditId === item?._id ? (
                                  <input
                                    type='text'
                                    name='editTeamDescription'
                                    id='editTeamDescription'
                                    maxLength='50'
                                    placeholder='Description'
                                    defaultValue={item?.description}
                                    className='focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm'
                                  />
                                ) : (
                                  item?.description
                                )}
                              </td>
                              <td className='px-3 py-2 font-normal text-xs tracking-wide text-left'>
                                {teamEditId === item?._id ? (
                                  <select
                                    id='editTeamDepartmentId'
                                    name='editTeamDepartmentId'
                                    className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs`}
                                    defaultValue={item?.departmentId?._id}>
                                    <option
                                      key='0'
                                      value={item?.departmentId?._id}>
                                      {item?.departmentId?.name}
                                    </option>
                                    {departmentServerData?.length > 0 ? (
                                      departmentServerData?.map((item) => {
                                        return (
                                          <option
                                            key={item?._id}
                                            value={item?._id}>
                                            {item?.name}
                                          </option>
                                        );
                                      })
                                    ) : (
                                      <option key='1' value=''>
                                        Loading...
                                      </option>
                                    )}
                                  </select>
                                ) : (
                                  item?.departmentId?.name
                                )}
                              </td>
                              {teamEditId === item?._id ? (
                                <td
                                  onClick={(e) => {
                                    editTeam(item?._id);
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Update
                                </td>
                              ) : (
                                <td
                                  onClick={(e) => {
                                    setTeamEditId(item?._id);
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Edit
                                </td>
                              )}
                              <td
                                onClick={(e) => {
                                  deleteOnClickTeam(item?._id);
                                }}
                                className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-red-600 text-center cursor-pointer'>
                                Delete
                              </td>
                            </tr>
                          ))}
                        {teamEditId === null && (
                          <tr className='hover:shadow-lg'>
                            <td className='px-3 py-2'>
                              <input
                                type='text'
                                name='newTeamName'
                                id='newTeamName'
                                maxLength='20'
                                placeholder='Name'
                                className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm`}
                              />
                            </td>
                            <td className='px-3 py-1'>
                              <input
                                type='text'
                                name='newTeamDescription'
                                id='newTeamDescription'
                                maxLength='50'
                                placeholder='Description'
                                className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm`}
                              />
                            </td>
                            <td className='px-3 py-1'>
                              <select
                                id='newTeamDepartmentId'
                                name='newTeamDepartmentId'
                                className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs`}>
                                <option>Select</option>
                                {departmentServerData?.length > 0 ? (
                                  departmentServerData?.map((item) => {
                                    return (
                                      <option key={item?._id} value={item?._id}>
                                        {item?.name}
                                      </option>
                                    );
                                  })
                                ) : (
                                  <option key='1' value=''>
                                    Loading...
                                  </option>
                                )}
                              </select>
                            </td>
                            <td
                              colSpan='2'
                              onClick={(e) => {
                                newTeam();
                              }}
                              className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                              Add
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className='pr-2'>
                    <h2 className='mt-3 ml-1 text-base font-semibold leading-7 text-gray-dark '>
                      Service Type
                    </h2>
                    <table className='table-auto w-full bg-white shadow rounded-sm border border-gray-100 '>
                      <thead className=' border-b-2 border-yellow'>
                        <tr>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                            Name
                          </th>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-left'>
                            Description
                          </th>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-left'>
                            Department
                          </th>
                          <th
                            colSpan='2'
                            className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'></th>
                        </tr>
                      </thead>
                      <tbody>
                        {serviceServerData?.length > 0 &&
                          serviceServerData?.map((item) => (
                            <tr key={item?._id} className='hover:shadow-lg'>
                              <td className='px-3 py-2 text-xs text-center'>
                                {serviceEditId === item?._id ? (
                                  <input
                                    type='text'
                                    name='editServiceName'
                                    id='editServiceName'
                                    maxLength='20'
                                    placeholder='Name'
                                    defaultValue={item?.name}
                                    className='focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm'
                                  />
                                ) : (
                                  item?.name
                                )}
                              </td>
                              <td className='px-3 py-2 font-normal text-xs tracking-wide text-left'>
                                {serviceEditId === item?._id ? (
                                  <input
                                    type='text'
                                    name='editServiceDescription'
                                    id='editServiceDescription'
                                    maxLength='50'
                                    placeholder='Description'
                                    defaultValue={item?.description}
                                    className='focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm'
                                  />
                                ) : (
                                  item?.description
                                )}
                              </td>
                              <td className='px-3 py-2 font-normal text-xs tracking-wide text-left'>
                                {serviceEditId === item?._id ? (
                                  <select
                                    id='editServiceDepartmentId'
                                    name='editServiceDepartmentId'
                                    className={`mt-1 block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs`}
                                    defaultValue={item?.departmentId?._id}>
                                    <option
                                      key='0'
                                      value={item?.departmentId?._id}>
                                      {item?.departmentId?.name}
                                    </option>
                                    {departmentForServiceServerData?.length >
                                    0 ? (
                                      departmentForServiceServerData?.map(
                                        (item) => {
                                          return (
                                            <option
                                              key={item?._id}
                                              value={item?._id}>
                                              {item?.name}
                                            </option>
                                          );
                                        },
                                      )
                                    ) : (
                                      <option key='1' value=''>
                                        Loading...
                                      </option>
                                    )}
                                  </select>
                                ) : (
                                  item?.departmentId?.name
                                )}
                              </td>
                              {serviceEditId === item?._id ? (
                                <td
                                  onClick={(e) => {
                                    editService(item?._id);
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Update
                                </td>
                              ) : (
                                <td
                                  onClick={(e) => {
                                    setServiceEditId(item?._id);
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Edit
                                </td>
                              )}
                              <td
                                onClick={(e) => {
                                  deleteOnClickService(item?._id);
                                }}
                                className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-red-600 text-center cursor-pointer'>
                                Delete
                              </td>
                            </tr>
                          ))}
                        {serviceEditId === null && (
                          <tr className='hover:shadow-lg'>
                            <td className='px-3 py-2'>
                              <input
                                type='text'
                                name='newServiceName'
                                id='newServiceName'
                                maxLength='20'
                                placeholder='Name'
                                className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm`}
                              />
                            </td>
                            <td className='px-3 py-1'>
                              <input
                                type='text'
                                name='newServiceDescription'
                                id='newServiceDescription'
                                maxLength='50'
                                placeholder='Description'
                                className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm`}
                              />
                            </td>
                            <td className='px-3 py-2'>
                              <select
                                id='newServiceDepartmentId'
                                name='newServiceDepartmentId'
                                className={`mt-1 block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs`}>
                                {departmentForServiceServerData?.length > 0 ? (
                                  departmentForServiceServerData?.map(
                                    (item) => {
                                      return (
                                        <option
                                          key={item?._id}
                                          value={item?._id}>
                                          {item?.name}
                                        </option>
                                      );
                                    },
                                  )
                                ) : (
                                  <option key='1' value=''>
                                    Loading...
                                  </option>
                                )}
                              </select>
                            </td>
                            <td
                              colSpan='2'
                              onClick={(e) => {
                                newService();
                              }}
                              className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                              Add
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className='pl-2'>
                    <h2 className='mt-3 ml-1 text-base font-semibold leading-7 text-gray-dark '>
                      Property Type
                    </h2>
                    <table className='table-auto w-full bg-white shadow rounded-sm border border-gray-100 '>
                      <thead className=' border-b-2 border-yellow'>
                        <tr>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                            Name
                          </th>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-left'>
                            Description
                          </th>
                          <th
                            colSpan='2'
                            className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'></th>
                        </tr>
                      </thead>
                      <tbody>
                        {propertyServerData?.length > 0 &&
                          propertyServerData.map((item) => (
                            <tr key={item?._id} className='hover:shadow-lg'>
                              <td className='px-3 py-2 text-xs text-center'>
                                {propertyEditId === item?._id ? (
                                  <input
                                    type='text'
                                    name='editPropertyName'
                                    id='editPropertyName'
                                    maxLength='20'
                                    placeholder='Name'
                                    defaultValue={item?.name}
                                    className='focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm'
                                  />
                                ) : (
                                  item?.name
                                )}
                              </td>
                              <td className='px-3 py-2 font-normal text-xs tracking-wide text-left'>
                                {propertyEditId === item?._id ? (
                                  <input
                                    type='text'
                                    name='editPropertyDescription'
                                    id='editPropertyDescription'
                                    maxLength='50'
                                    placeholder='Description'
                                    defaultValue={item?.description}
                                    className='focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm'
                                  />
                                ) : (
                                  item?.description
                                )}
                              </td>
                              {propertyEditId === item?._id ? (
                                <td
                                  onClick={(e) => {
                                    editProperty(item?._id);
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Update
                                </td>
                              ) : (
                                <td
                                  onClick={(e) => {
                                    setPropertyEditId(item?._id);
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Edit
                                </td>
                              )}
                              <td
                                onClick={(e) => {
                                  deleteOnClickProperty(item?._id);
                                }}
                                className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-red-600 text-center cursor-pointer'>
                                Delete
                              </td>
                            </tr>
                          ))}
                        {propertyEditId === null && (
                          <tr className='hover:shadow-lg'>
                            <td className='px-3 py-2'>
                              <input
                                type='text'
                                name='newPropertyName'
                                id='newPropertyName'
                                maxLength='20'
                                placeholder='Name'
                                className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm`}
                              />
                            </td>
                            <td className='px-3 py-1'>
                              <input
                                type='text'
                                name='newPropertyDescription'
                                id='newPropertyDescription'
                                maxLength='50'
                                placeholder='Description'
                                className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm`}
                              />
                            </td>
                            <td
                              colSpan='2'
                              onClick={(e) => {
                                newProperty();
                              }}
                              className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                              Add
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className='pr-2'>
                    <h2 className='mt-3 ml-1 text-base font-semibold leading-7 text-gray-dark '>
                      Sub-Service Type
                    </h2>
                    <table className='table-auto w-full bg-white shadow rounded-sm border border-gray-100 '>
                      <thead className=' border-b-2 border-yellow'>
                        <tr>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                            Service
                          </th>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                            Name
                          </th>
                          <th
                            colSpan='2'
                            className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'></th>
                        </tr>
                      </thead>
                      <tbody>
                        {subServiceServerData?.length > 0 &&
                          subServiceServerData?.map((item) => (
                            <tr key={item?._id} className='hover:shadow-lg'>
                              <td className='px-3 py-2 text-xs text-center'>
                                {subServiceEditId === item?._id ? (
                                  <select
                                    id='editSubServiceSuperId'
                                    name='editSubServiceSuperId'
                                    defaultValue={item?.serviceId?._id}
                                    className={`mt-1 block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs`}>
                                    {serviceServerData?.length > 0 ? (
                                      serviceServerData?.map((item) => {
                                        return (
                                          <option
                                            key={item?._id}
                                            value={item?._id}>
                                            {item?.name}
                                          </option>
                                        );
                                      })
                                    ) : (
                                      <option key='1' value=''>
                                        Loading...
                                      </option>
                                    )}
                                  </select>
                                ) : (
                                  item?.serviceId?.name
                                )}
                              </td>
                              <td className='px-3 py-2 text-xs text-center'>
                                {subServiceEditId === item?._id ? (
                                  <input
                                    type='text'
                                    name='editSubServiceName'
                                    id='editSubServiceName'
                                    maxLength='50'
                                    placeholder='Name'
                                    defaultValue={item?.name}
                                    className='focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm'
                                  />
                                ) : (
                                  item?.name
                                )}
                              </td>
                              {subServiceEditId === item?._id ? (
                                <td
                                  onClick={(e) => {
                                    editSubService(item?._id);
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Update
                                </td>
                              ) : (
                                <td
                                  onClick={(e) => {
                                    setSubServiceEditId(item?._id);
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Edit
                                </td>
                              )}
                              <td
                                onClick={(e) => {
                                  deleteOnClickSubService(item?._id);
                                }}
                                className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-red-600 text-center cursor-pointer'>
                                Delete
                              </td>
                            </tr>
                          ))}
                        {subServiceEditId === null && (
                          <tr className='hover:shadow-lg'>
                            <td className='px-3 py-2'>
                              <select
                                id='newSubServiceSuperId'
                                name='newSubServiceSuperId'
                                className={`mt-1 block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs`}>
                                {serviceServerData?.length > 0 ? (
                                  serviceServerData?.map((item) => {
                                    return (
                                      <option key={item?._id} value={item?._id}>
                                        {item?.name}
                                      </option>
                                    );
                                  })
                                ) : (
                                  <option key='1' value=''>
                                    Loading...
                                  </option>
                                )}
                              </select>
                            </td>
                            <td className='px-3 py-1'>
                              <input
                                type='text'
                                name='newSubServiceName'
                                id='newSubServiceName'
                                maxLength='40'
                                placeholder='Name'
                                className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm`}
                              />
                            </td>
                            <td
                              colSpan='2'
                              onClick={(e) => {
                                newSubService();
                              }}
                              className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                              Add
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className='pl-2'>
                    <h2 className='mt-3 ml-1 text-base font-semibold leading-7 text-gray-dark '>
                      Sub-Property Type
                    </h2>
                    <table className='table-auto w-full bg-white shadow rounded-sm border border-gray-100 '>
                      <thead className=' border-b-2 border-yellow'>
                        <tr>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                            Property
                          </th>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                            Name
                          </th>
                          <th
                            colSpan='2'
                            className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'></th>
                        </tr>
                      </thead>
                      <tbody>
                        {subPropertyServerData.length > 0 &&
                          subPropertyServerData.map((item) => (
                            <tr key={item?._id} className='hover:shadow-lg'>
                              <td className='px-3 py-2 text-xs text-center'>
                                {subPropertyEditId === item?._id ? (
                                  <select
                                    id='editSubPropertySuperId'
                                    name='editSubPropertySuperId'
                                    defaultValue={item?.propertyOptionId?._id}
                                    className={`mt-1 block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs`}>
                                    {propertyServerData?.length > 0 ? (
                                      propertyServerData?.map((item) => {
                                        return (
                                          <option
                                            key={item?._id}
                                            value={item?._id}>
                                            {item?.name}
                                          </option>
                                        );
                                      })
                                    ) : (
                                      <option key='1' value=''>
                                        Loading...
                                      </option>
                                    )}
                                  </select>
                                ) : (
                                  item?.propertyOptionId?.name
                                )}
                              </td>
                              <td className='px-3 py-2 text-xs text-center'>
                                {subPropertyEditId === item?._id ? (
                                  <input
                                    type='text'
                                    name='editSubPropertyName'
                                    id='editSubPropertyName'
                                    maxLength='50'
                                    placeholder='Name'
                                    defaultValue={item?.name}
                                    className='focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm'
                                  />
                                ) : (
                                  item?.name
                                )}
                              </td>
                              {subPropertyEditId === item?._id ? (
                                <td
                                  onClick={(e) => {
                                    editSubProperty(item?._id);
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Update
                                </td>
                              ) : (
                                <td
                                  onClick={(e) => {
                                    setSubPropertyEditId(item?._id);
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Edit
                                </td>
                              )}
                              <td
                                onClick={(e) => {
                                  deleteOnClickSubProperty(item?._id);
                                }}
                                className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-red-600 text-center cursor-pointer'>
                                Delete
                              </td>
                            </tr>
                          ))}
                        {subPropertyEditId === null && (
                          <tr className='hover:shadow-lg'>
                            <td className='px-3 py-1'>
                              <select
                                id='newSubPropertySuperId'
                                name='newSubPropertySuperId'
                                className={`mt-1 block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs`}>
                                {propertyServerData?.length > 0 ? (
                                  propertyServerData?.map((item) => {
                                    return (
                                      <option key={item?._id} value={item?._id}>
                                        {item?.name}
                                      </option>
                                    );
                                  })
                                ) : (
                                  <option key='1' value=''>
                                    Loading...
                                  </option>
                                )}
                              </select>
                            </td>
                            <td className='px-3 py-1'>
                              <input
                                type='text'
                                name='newSubPropertyName'
                                id='newSubPropertyName'
                                maxLength='50'
                                placeholder='Name'
                                className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm`}
                              />
                            </td>
                            <td
                              colSpan='2'
                              onClick={(e) => {
                                newSubProperty();
                              }}
                              className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                              Add
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <h2 className='mt-3 ml-1 text-base font-semibold leading-7 text-gray-dark '>
                      PIF Locations
                    </h2>
                    <table className='table-auto w-full bg-white shadow rounded-sm border border-gray-100 '>
                      <thead className=' border-b-2 border-yellow'>
                        <tr>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                            Name
                          </th>
                          <th
                            colSpan='2'
                            className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'></th>
                        </tr>
                      </thead>
                      <tbody>
                        {pifLocationServerData.length > 0 &&
                          pifLocationServerData.map((item) => (
                            <tr key={item?._id} className='hover:shadow-lg'>
                              <td className='px-3 py-2 text-xs text-center'>
                                {pifLocationEditId === item?._id ? (
                                  <input
                                    type='text'
                                    name='editPIFLocationName'
                                    id='editPIFLocationName'
                                    maxLength='50'
                                    placeholder='Name'
                                    defaultValue={item?.name}
                                    className='focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm'
                                  />
                                ) : (
                                  item?.name
                                )}
                              </td>
                              {pifLocationEditId === item?._id ? (
                                <td
                                  onClick={(e) => {
                                    editPIFLocation(item?._id);
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Update
                                </td>
                              ) : (
                                <td
                                  onClick={(e) => {
                                    setPIFLocationEditId(item?._id);
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Edit
                                </td>
                              )}
                              <td
                                onClick={(e) => {
                                  deleteOnClickPIFLocation(item?._id);
                                }}
                                className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-red-600 text-center cursor-pointer'>
                                Delete
                              </td>
                            </tr>
                          ))}
                        {pifLocationEditId === null && (
                          <tr className='hover:shadow-lg'>
                            <td className='px-3 py-1'>
                              <input
                                type='text'
                                name='newPIFLocationName'
                                id='newPIFLocationName'
                                maxLength='50'
                                placeholder='Name'
                                className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm`}
                              />
                            </td>
                            <td
                              colSpan='2'
                              onClick={(e) => {
                                newPIFLocation();
                              }}
                              className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                              Add
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className='pr-2 col-span-2'>
                    <h2 className='mt-3 ml-1 text-base font-semibold leading-7 text-gray-dark '>
                      Service Sub Status
                    </h2>
                    <table className='table-auto w-full bg-white shadow rounded-sm border border-gray-100 '>
                      <thead className=' border-b-2 border-yellow'>
                        <tr>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                            Service
                          </th>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-left'>
                            SubService
                          </th>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-left'>
                            Name
                          </th>
                          <th className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-left'>
                            Description
                          </th>
                          <th
                            colSpan='2'
                            className='px-5 py-2 text-gray-dark text-sm font-semibold tracking-wide text-center'></th>
                        </tr>
                      </thead>
                      <tbody>
                        {serviceSubStatusServerData?.length > 0 &&
                          serviceSubStatusServerData?.map((item) => (
                            <tr key={item?._id} className='hover:shadow-lg'>
                              <td className='px-3 py-2 text-xs text-center'>
                                {serviceSubStatusEditId === item?._id ? (
                                  <select
                                    id='editServiceSubStatusSuperId'
                                    name='editServiceSubStatusSuperId'
                                    defaultValue={item?.serviceId?._id}
                                    className={`mt-1 block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs`}>
                                    {serviceServerData?.length > 0 ? (
                                      serviceServerData?.map((item) => {
                                        return (
                                          <option
                                            key={item?._id}
                                            value={item?._id}>
                                            {item?.name}
                                          </option>
                                        );
                                      })
                                    ) : (
                                      <option key='1' value=''>
                                        Loading...
                                      </option>
                                    )}
                                  </select>
                                ) : (
                                  item?.serviceId?.name
                                )}
                              </td>
                              <td className='px-3 py-2 text-xs text-center'>
                                {serviceSubStatusEditId === item?._id ? (
                                  <select
                                    id='editServiceSubStatusSubServiceId'
                                    name='editServiceSubStatusSubServiceId'
                                    defaultValue={item?.subServiceId?._id}
                                    className={`mt-1 block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs`}>
                                    {subServiceForSubStatusServerData?.length >
                                    0 ? (
                                      subServiceForSubStatusServerData?.map(
                                        (item) => {
                                          return (
                                            <option
                                              key={item?._id}
                                              value={item?._id}>
                                              {item?.name}
                                            </option>
                                          );
                                        },
                                      )
                                    ) : (
                                      <option key='1' value=''>
                                        Loading...
                                      </option>
                                    )}
                                  </select>
                                ) : (
                                  item?.subServiceId?.name
                                )}
                              </td>
                              <td className='px-3 py-2 text-xs text-center'>
                                {serviceSubStatusEditId === item?._id ? (
                                  <input
                                    type='text'
                                    name='editServiceSubStatusName'
                                    id='editServiceSubStatusName'
                                    maxLength='20'
                                    placeholder='Name'
                                    defaultValue={item?.name}
                                    className='focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm'
                                  />
                                ) : (
                                  item?.name
                                )}
                              </td>
                              <td className='px-3 py-2 font-normal text-xs tracking-wide text-left'>
                                {serviceSubStatusEditId === item?._id ? (
                                  <input
                                    type='text'
                                    name='editServiceSubStatusDescription'
                                    id='editServiceSubStatusDescription'
                                    maxLength='50'
                                    placeholder='Description'
                                    defaultValue={item?.description}
                                    className='focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm'
                                  />
                                ) : (
                                  item?.description
                                )}
                              </td>

                              {serviceSubStatusEditId === item?._id ? (
                                <td
                                  onClick={(e) => {
                                    editServiceSubStatus(item?._id);
                                    console.log(item?._id);
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Update
                                </td>
                              ) : (
                                <td
                                  onClick={(e) => {
                                    setServiceSubStatusEditId(item?._id);
                                    updateSubServiceForSubStatus(
                                      item?.serviceId?._id,
                                    );
                                  }}
                                  className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                  Edit
                                </td>
                              )}
                              <td
                                onClick={(e) => {
                                  deleteOnClickServiceSubStatus(item?._id);
                                }}
                                className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-red-600 text-center cursor-pointer'>
                                Delete
                              </td>
                            </tr>
                          ))}
                        {serviceSubStatusEditId === null && (
                          <tr className='hover:shadow-lg'>
                            <td className='px-3 py-2'>
                              <select
                                id='newServiceSubStatusSuperId'
                                name='newServiceSubStatusSuperId'
                                onChange={(e) => {
                                  updateSubServiceForSubStatus(e.target.value);
                                }}
                                className={`mt-1 block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs`}>
                                <option key='0' value=''>
                                  Select
                                </option>
                                {serviceServerData?.length > 0 ? (
                                  serviceServerData?.map((item) => {
                                    return (
                                      <option key={item?._id} value={item?._id}>
                                        {item?.name}
                                      </option>
                                    );
                                  })
                                ) : (
                                  <option key='1' value=''>
                                    Loading...
                                  </option>
                                )}
                              </select>
                            </td>
                            <td className='px-3 py-2'>
                              <select
                                id='newServiceSubStatusSubServiceId'
                                name='newServiceSubStatusSubServiceId'
                                className={`mt-1 block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs`}>
                                {subServiceForSubStatusServerData?.length >
                                0 ? (
                                  subServiceForSubStatusServerData?.map(
                                    (item) => {
                                      return (
                                        <option
                                          key={item?._id}
                                          value={item?._id}>
                                          {item?.name}
                                        </option>
                                      );
                                    },
                                  )
                                ) : (
                                  <option key='1' value=''>
                                    Loading...
                                  </option>
                                )}
                              </select>
                            </td>
                            <td className='px-3 py-2'>
                              <input
                                type='text'
                                name='newServiceSubStatusName'
                                id='newServiceSubStatusName'
                                maxLength='20'
                                placeholder='Name'
                                className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm`}
                              />
                            </td>
                            <td className='px-3 py-2'>
                              <input
                                type='text'
                                name='newServiceSubStatusDescription'
                                id='newServiceSubStatusDescription'
                                maxLength='100'
                                placeholder='Description'
                                className={` focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-xs rounded-sm`}
                              />
                            </td>
                            <td
                              colSpan='2'
                              onClick={(e) => {
                                newServiceSubStatus();
                              }}
                              className='px-5 py-2 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                              Add
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className='block sm:hidden'>
                <div className='grid justify-items-center'>
                  <img
                    src='/assets/images/desktop_only.svg'
                    className='mt-12 w-56 block'
                    alt='Desktop Only'
                  />
                  <h2 className='mt-10 text-center text-base  font-base leading-0 text-gray-dark sm:text-lg '>
                    Considering user experience, this page is accessible only
                    via <strong>Landscape</strong> screens.
                  </h2>
                  <button
                    onClick={(e) => {
                      navigate(-1);
                    }}
                    className='inline-flex mt-5 justify-center py-2 px-4 border-yellow-2 border shadow-sm text-xs font-medium rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default InputSettings;
